import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

// svgs
import lightningSVG from '../../inlineSVGs/lightningSVG';
import notePurpleMugicsSVG from '../../inlineSVGs/notePurpleMugicsSVG';
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';

// components
import { ButtonSimple } from '../../Elements/Buttons';

// styles
import '../stylesModal.css';
import './styles.css';

const GeneralMessage = ({ header, content, closeModal, isModalOpen, list, confirm, isCancel }) => {
    const renderList = (list) => {
        if (!list) return;

        return list.map((l, i) => <p key={'message' + i} className="list-item">{l}</p>)
    };

    const onConfirm = () => {
        if (confirm) {
            confirm();
        }

        closeModal();
    };

    const renderButtons = () => {
        if (!isCancel) return <ButtonSimple onPress={() => onConfirm()} label="אישור" customClass="general-message-button"/>;

        return (
            <div className="buttons-wrapper">
                <ButtonSimple onPress={() => closeModal()} label="ביטול" customClass="general-message-button"/>
                <ButtonSimple onPress={() => onConfirm()} label="אישור" customClass="general-message-button"/>
            </div>
        )
    };

    return (
        <Modal
            isOpen={isModalOpen}
            contentLabel="Modal"
            className="modal-wrapper general-message-modal rtl"
            style={{overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    zIndex: 9999
                }}}
        >
            <div className="close-button-container">
                <div onClick={closeModal} >
                    <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                </div>
            </div>
            <SVGInline svg={notePurpleMugicsSVG} width="95px" className="mugics-icon" component="i"/>

            <div className="content">
                <h3>{header}</h3>
                <SVGInline svg={lightningSVG} width="30px" fill="#08FCC9"/>
                <p>{content}</p>
                { list ? <div className="list-items">{renderList(list)}</div> : null }
                {renderButtons()}
            </div>

        </Modal>
    )
};

GeneralMessage.propTypes = {
    isCancel: PropTypes.bool,
    header: PropTypes.string,
    content: PropTypes.string,
    list: PropTypes.array,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    confirm: PropTypes.func
};

export default GeneralMessage;



// WEBPACK FOOTER //
// ./src/Components/Modals/GeneralMessage/GeneralMessage.js